{
  "list": {
    "title": "Clase",
    "timetable": "Orar",
    "list": "Listă",
    "addClass": "Adaugă clasă",
    "col": {
      "name": "Clasă",
      "teacher": "Profesor",
      "type": "Tip",
      "level": "Nivel",
      "day": "Zi",
      "time": "Ora",
      "enrolled": "Înscriși"
    }
  },
  "form": {
    "heading": "Adaugă clasă",
    "name": "Nume",
    "danceType": "Tip de dans",
    "danceTypePlaceholder": "Tip…",
    "level": "Nivel",
    "levelPlaceholder": "Nivel…",
    "teacher": "Profesor",
    "teacherPlaceholder": "Profesor…",
    "day": "Zi",
    "capacity": "Capacitate (gol = nelimitat)",
    "startTime": "Ora de început",
    "endTime": "Ora de sfârșit",
    "create": "Creează",
    "nameRequired": "Numele clasei este obligatoriu",
    "saveFailed": "Eroare"
  },
  "detail": {
    "backToClasses": "Clase",
    "noTeacher": "Fără profesor",
    "day": "Zi",
    "time": "Ora",
    "capacity": "Capacitate",
    "enrolled": "Înscriși",
    "unlimited": "Nelimitat",
    "enrolledStudents": "Cursanți înscriși",
    "addStudentPlaceholder": "Adaugă cursant…",
    "enroll": "Înscrie",
    "remove": "Elimină",
    "noStudents": "Niciun cursant înscris",
    "upcomingSessions": "Ședințe viitoare",
    "noSessions": "Nicio ședință"
  },
  "toast": {
    "created": "Clasă creată",
    "enrolled": "Înscris"
  },
  "days": {
    "monday": "Luni",
    "tuesday": "Marți",
    "wednesday": "Miercuri",
    "thursday": "Joi",
    "friday": "Vineri",
    "saturday": "Sâmbătă",
    "sunday": "Duminică"
  },
  "daysShort": {
    "monday": "Lun",
    "tuesday": "Mar",
    "wednesday": "Mie",
    "thursday": "Joi",
    "friday": "Vin",
    "saturday": "Sâm",
    "sunday": "Dum"
  },
  "sessionStatus": {
    "scheduled": "Programată",
    "cancelled": "Anulată",
    "completed": "Finalizată"
  }
}
